import Vue from 'vue';

const success = (context, response) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  toastr.success(response.msg);
  swal({
      title: context.$t('swal_popup.deleted'),
      text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${context.$t('swal_popup.template_deleted')}</div>`,
      type: "warning",
      showCancelButton: false,
      confirmButtonClass: "btn-warning",
      confirmButtonText: context.$t('button.ok'),
      closeOnConfirm: true,
      html: true
    },
    function() {
      $(".confirm").addClass("disabled");
      $(".pulseWarning").hide();
    });
  $('#redact').html("");
  context.getAll();
};

const failed = (context, error) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  context.showToasterError(error);
};

export default (context, id) => {
  return Vue.$http.delete(`schedule-payments/${id}`)
    .then(response => {
      if (response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch(error => {
        failed(context, error)
    });
}



// WEBPACK FOOTER //
// ./src/app/services/schedule-payment/destroy.js